<template>
  <div>
    <b-input v-if="disabled" :disabled="disabled" :value="this.value.name" class="form-control"/>
    <multi-select v-else :value="value"  label="searchName" :multiple="false" :options="clients" :loading="loading" :searchable="true" track-by="id"
                  :placeholder="this.$t('SEARCH')"
                  :select-label="this.$t('APPLY')"
                  tag-placeholder="Odaberi"
                  deselectLabel="Izbriši"
                  @search-change="search"
                  @input="onSelect"
                  ref="vms"
    >
      <template v-slot:noResult>
        Nema rezultata
      </template>
      <template v-slot:noOptions>
        Lista je prazna
      </template>
    </multi-select>
  </div>

</template>

<script>
import {getClientList} from "@/services/client";
import MultiSelect from 'vue-multiselect'
import _debounce from 'lodash/debounce'

export default {
  name: "SearchClient",
  props:{
    value: {
      type:Object,
      default: function () {
        return {
          id: null,
          name:null
        }
      }
    },
    disabled:{
      type: Boolean,
      default: false
    },
    focusable: {
      type: Boolean,
      default: false
    }
  },
  data(){
    return {
      clients: [],
      loading: false
    }
  },
  components: {
    MultiSelect
  },
  methods: {
    search: _debounce(function (value) {
      if (value === "") {
        return
      }
      this.loading = true
      getClientList({name: value})
        .then(response => {
          this.clients = response.data.items

        }).finally(() => {
        this.loading = false
      })
    }, 600),
    onSelect(value) {
      if (value === null) {
        this.$emit("input", {id: null, name: null})
        this.clients = []
      } else {
        this.$emit("input", value)
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      if(this.focusable && this.$refs.vms) {
        this.$refs.vms.$el.focus()
      }
    })
  }
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
.multiselect__tags {
  min-height: 35px !important;
  display: block;
  padding: 0px 37px 0 7px !important;
  border-radius: 5px;
  border: 1px solid #e8e8e8;
  background: #fff;
  font-size: 14px;
}
.multiselect__single {
  font-size: 14px;
  padding-top: 5px;
  margin-bottom: unset;

}
.multiselect, .multiselect__input {
  min-height: 13px;
  line-height: 16px;
}
</style>
